export const _assignmentsFr = {
    home: 'Accueil',
    planning: 'Planning',
    noAssignment: 'Aucune affectation trouvée',
    selectAssignment: 'Sélectionner une affectation',
    vehiclesSynoptic: 'Synoptique des véhicules',
    staffSynoptic: 'Synoptique du personnel',
    departureTicket: 'Ticket de départ',
};

export const _assignmentsEn = {
    home: 'Home',
    planning: 'Planning',
    noAssignment: 'No assignment found',
    selectAssignment: 'Select an assignment',
    vehiclesSynoptic: 'Vehicles synoptic',
    staffSynoptic: 'Staff synoptic',
    departureTicket: 'Departure ticket',
};

export const _assignmentsDe = {
    home: 'Zuhause',
    planning: 'Planung',
    noAssignment: 'Keine Zuweisung gefunden',
    selectAssignment: 'Wählen Sie eine Zuweisung aus',
    vehiclesSynoptic: 'Fahrzeugsynoptik',
    staffSynoptic: 'Personalsynoptik',
    departureTicket: 'Abfahrticket',
};
